import { render, staticRenderFns } from "./AppFormField.vue?vue&type=template&id=18b56330"
import script from "./AppFormField.vue?vue&type=script&lang=js"
export * from "./AppFormField.vue?vue&type=script&lang=js"
import style0 from "./AppFormField.vue?vue&type=style&index=0&id=18b56330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VSelect,VTextField,VTextarea})
